<script setup lang="ts">
import type { ModelValue } from "@kaleidoscope-solutions/ks-design-system"
import { useEngineModel } from "@/utils/useEngineModel"
import { KDropdown } from "@kaleidoscope-solutions/ks-design-system"
import { computedAsync, useVModel } from "@vueuse/core"

interface Props {
  modelValue: string
  keyType: string
}

const props = defineProps<Props>()

const emit = defineEmits<Emits>()
interface Emits {
  (event: "update:modelValue", value: string | number | string[]): void
  (event: "create", value: string): void
  (event: "closed"): void
}

const model = useEngineModel()

const items = computedAsync<ModelValue[]>(async () => {
  return await model.api.itemNames(props.keyType)
}, [])

const value = useVModel(props, "modelValue")
</script>

<template>
  <KDropdown
    v-model="value"
    placeholder="Column to import"
    :nullable="false"
    :items="items"
    class="w-52 bg-white"
    @closed="emit('closed')"
    @create="emit('create', $event)"
  >
    <template #selected="{ selected, open }">
      <slot
        name="selected"
        :selected="selected"
        :open="open"
      >
        <span
          v-if="selected"
          class="text-gray-700"
        >Column to import</span>
      </slot>
    </template>
  </KDropdown>
</template>
